import React, { FC } from 'react';

import RecentTrades from '@buyside/components/presentation/InsiderTradesPage/recentTrades';
import LargestTrades from '@buyside/components/presentation/InsiderTradesPage/largestTrades';
import ErrorBoundary from '@buyside/components/presentation/ErrorBoundary/errorBoundary';

const InsiderTradesPageRoot: FC = () => {
  return (
    <>
      <h2>Insider Trades</h2>
      <br />
      <ErrorBoundary pageName="recent trades">
        <RecentTrades />
      </ErrorBoundary>
      <br />
      <br />
      <ErrorBoundary pageName="largest trades">
        <LargestTrades />
      </ErrorBoundary>
    </>
  );
};

export default InsiderTradesPageRoot;
